import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { initLenis, scrollTopNow, scrollToEl } from "@/lib/smoothScroll";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Membership from "@/pages/Membership";
import Contact from "@/pages/Contact";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToEl(hash), 150);
      return () => clearTimeout(t);
    }
    scrollTopNow();
  }, [pathname, hash]);
  return null;
};

const LegacyServiceRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/services-luxury-spa/${slug}`} replace />;
};

function App() {
  useEffect(() => {
    const destroy = initLenis();
    return destroy;
  }, []);

  return (
    <div className="App min-h-screen bg-[#0B0B0C] text-stone-200">
      <BrowserRouter>
        <ScrollManager />
        <div className="grain-overlay" aria-hidden="true" />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us-luxury-spa" element={<About />} />
            <Route path="/services-luxury-spa" element={<Services />} />
            <Route path="/services-luxury-spa/:slug" element={<ServiceDetail />} />
            <Route path="/membership-luxury-spa" element={<Membership />} />
            <Route path="/contact-us-luxury-spa" element={<Contact />} />
            <Route path="/about" element={<Navigate to="/about-us-luxury-spa" replace />} />
            <Route path="/services" element={<Navigate to="/services-luxury-spa" replace />} />
            <Route path="/services/:slug" element={<LegacyServiceRedirect />} />
            <Route path="/membership" element={<Navigate to="/membership-luxury-spa" replace />} />
            <Route path="/contact" element={<Navigate to="/contact-us-luxury-spa" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
      </BrowserRouter>
    </div>
  );
}

export default App;
